import React from "react";
import _ from "lodash";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  Show,
  TabbedShowLayout,
  Tab,
  TextField,
  DateField,
  Edit,
  SimpleForm,
  DisabledInput,
  TextInput,
  Create,
  required,
  minLength,
  maxLength
} from "react-admin";
import {
  TemplateBlocksField,
  TemplateBlocksInputField
} from "../../../components/guide/TemplateBlocksField";
import TemplatePreviewField from "../../../components/guide/TemplatePreviewField";

const style = {
  info: {
    display: "inline-block",
    verticalAlign: "top",
    marginRight: "2em",
    minWidth: "8em"
  },
  booleanInfo: {
    display: "inline-block",
    verticalAlign: "top",
    marginRight: "2em"
  }
};

const Title = ({ record }) => {
  return <span>Template {record ? `"${_.truncate(record.title)}"` : ""}</span>;
};

export const TemplateShow = withStyles(style)(({ classes, ...props }) => {
  return (
    <Show title={<Title />} {...props}>
      <TabbedShowLayout>
        <Tab label="summary">
          <TextField source="id" label="ID" />
          <DateField
            showTime
            source="create_date"
            label="建立時間"
            className={classes.info}
          />
          <DateField
            showTime
            source="modify_date"
            label="編輯時間"
            className={classes.info}
          />
          <TextField source="title" label="標題" />
          <TemplateBlocksField label="Template Blocks" />
        </Tab>
        <Tab label="preview">
          <TemplatePreviewField label="preview" />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
});

const validateTemplateName = [required(), minLength(2), maxLength(50)];

export const TemplateEdit = props => (
  <Edit {...props}>
    <SimpleForm redirect="show">
      <DisabledInput label="ID" source="id" />
      <TextInput label="標題" source="title" validate={validateTemplateName} />
      <TemplateBlocksInputField label="Template Blocks" source="blocks" />
    </SimpleForm>
  </Edit>
);

export const TemplateCreate = props => (
  <Create {...props}>
    <SimpleForm
      redirect="show"
      defaultValue={{
        blocks: {},
        layout: 1
      }}
    >
      <TextInput label="標題" source="title" validate={validateTemplateName} />
      <TemplateBlocksInputField label="Template Blocks" source="blocks" />
    </SimpleForm>
  </Create>
);
